import { Injectable, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ReplaySubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LanguagesService {
  private readonly translate = inject(TranslateService);

  private sourceLanguages = new ReplaySubject<Record<string, string>>(1);
  private targetLanguages = new ReplaySubject<Record<string, string>>(1);
  private rephraseLanguages = new ReplaySubject<Record<string, string>>(1);

  public sourceLangs$ = this.sourceLanguages.asObservable();
  public targetLangs$ = this.targetLanguages.asObservable();
  public rephraseLangs$ = this.rephraseLanguages.asObservable();

  constructor() {
    this.translate.stream('Text.SourceLanguages').subscribe((res: Record<string, string>) => {
      this.sourceLanguages.next(res);
    });
    this.translate.stream('Text.TargetLanguages').subscribe((res: Record<string, string>) => {
      this.targetLanguages.next(res);
    });
    this.translate.stream('Text.RephraseLanguages').subscribe((res: Record<string, string>) => {
      this.rephraseLanguages.next(res);
    });
  };
}
